import React from "react";
import PropTypes from "prop-types";
import Route from "react-router-dom/Route";
import Switch from "react-router-dom/Switch";
import Header from "./common/Header";
import Footer from "./common/Footer";
import HomePage from "./homePage/HomePage";
import CommissionsPage from "./commissions/CommissionsPage";
import GalleryPage from "./gallery/GalleryPage";
import SketchADayPage from "./sketchADay/SketchADayPage";
import ContactPage from "./contact/ContactPage";
import ErrorPage from "./ErrorPage";
import NotFoundPage from "./NotFoundPage";
import { Helmet } from "react-helmet";

class App extends React.Component {
    render() {
        return (
            <div>
                <Helmet>
                    <title>Ailsa Lyn Artist</title>
                    <meta property="og:title" content="Ailsa Lyn Artist" />
                    <meta
                        property="og:description"
                        content="Ailsa Lyn - A Suffolk based artist specialising collages and watercolours."
                    />
                    <meta
                        property="og:image"
                        content="https://ailsalyn.co.uk/images/sudburymeadows-hero.jpg"
                    />
                </Helmet>
                <Header />
                <Switch>
                    <Route exact path="/" component={HomePage} />
                    <Route path="/gallery" component={GalleryPage} />
                    <Route
                        path="/sketch-a-day/:date"
                        component={SketchADayPage}
                    />
                    <Route path="/sketch-a-day" component={SketchADayPage} />
                    <Route path="/commissions" component={CommissionsPage} />
                    <Route path="/contact" component={ContactPage} />
                    <Route path="/error" component={ErrorPage} />
                    <Route component={NotFoundPage} />
                </Switch>
                <Footer />
            </div>
        );
    }
}
App.propTypes = {
    children: PropTypes.element
};

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js